import { combineReducers } from "redux";
import {
  mobileReducer,
  locationReducer,
  storeReducer,
  storeFIlterReducer,
  categoryProductsReducer,
  cartOrderDetailsReducer,
  cartQuantityReducer,
  prescribeDataReducer,
} from "./Reducers";

export const rootReducer = combineReducers({
  mobileNumber: mobileReducer,
  location: locationReducer,
  storeDetails: storeReducer,
  storeFilter: storeFIlterReducer,
  categoryProducts: categoryProductsReducer,
  cartOrderDetails: cartOrderDetailsReducer,
  cartQuantity: cartQuantityReducer,
  prescribeData: prescribeDataReducer,
});
